export function populateUser(data) {
    return {
        type: "@@acuant/POPULATE_USER_PROFILE",
        payload: data
    }
}